//
//
//
//


export default {
    props: {
        lib: { default: 'zondicons' },
        icon: { default: 'adjust' },
        size: { default: 'small' }
    },

    data: function data() {
        return {
            src: '/assets/prototype/' + this.lib + '/' + this.icon + '.svg',
            output: '...'
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;
        var cache = new Map();

        if ($el.src.includes("md/")) {
            var $icon = 'ic_' + $el.icon + '_48px';
            $el.src = '/assets/prototype/' + this.lib + '/svg/production/' + $icon + '.svg';
        }

        if (!cache.has(this.src)) {
            try {
                axios.get(this.src).then(function (response) {
                    cache.set(_this.src, response.data);
                    _this.output = cache.get(_this.src);
                });
            } catch (e) {
                cache.delete(this.src);
            }
        }
        if (cache.has(this.src)) {
            this.output = cache.get(this.src);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/layout/Svg.vue
// module id = BNEa
// module chunks = 0 1